/** Familiar (10999): hours 1–23 → duration_hours; days → day_count, duration_hours null */
export function encodeFamiliarDuration(value, unit) {
    const n = Math.max(0, Math.round(Number(value) || 0))
    if (unit === 'hours') {
        const hours = Math.min(23, Math.max(1, n || 1))
        return { day_count: 0, duration_hours: hours }
    }
    return { day_count: Math.min(30, n), duration_hours: null }
}

export function decodeFamiliarDuration(row) {
    const h = row?.duration_hours
    if (h != null && h !== '' && Number(h) > 0) {
        return { durationValue: Number(h), durationUnit: 'hours' }
    }
    return { durationValue: row?.day_count ?? 3, durationUnit: 'days' }
}
